import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';

import App from './App/index';
import * as serviceWorker from './serviceWorker';
import config from './config';
import {store, persistor} from './store/store'
import {PersistGate} from "redux-persist/integration/react"

const app = (
    <Provider store={store}>
        <PersistGate persistor={persistor}>
        <BrowserRouter basename={config.basename}> 
            {/* basename="/datta-able" */}             
                <App />                       
        </BrowserRouter>
        </PersistGate> 
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
